import { useTier } from "../../Context/TierProvider";
import { type InsightsPageId } from "../../Navigation/config/pages";
import { InsightsContextProvider } from "./context";
import { InsightsDetails } from "./InsightDetails/InsightDetails";
import { InsightsList } from "./InsightsList/InsightsList";
import { InsightsUpsell } from "./InsightsUpsell/InsightsUpsell";
import { NewInsight } from "./NewInsight/NewInsight";

export function InsightsRouter({ pageId }: { pageId: InsightsPageId }) {
  const { loading, isFeatureEntitled, getFeatureLimit } = useTier();
  const isInsightsEntitled = isFeatureEntitled("governance:insights");
  const featureLimit = getFeatureLimit("governance:insights") as string[];
  const isOnlyCustomInsights = featureLimit?.length === 1 && featureLimit[0] === "custom#ALL";
  const showUpsell = !isInsightsEntitled || isOnlyCustomInsights;

  if (loading) return <></>;

  // Access to details blocked via featureGate on access control configuration
  if (pageId === "insights:details") {
    return (
      <InsightsContextProvider>
        <InsightsDetails />
      </InsightsContextProvider>
    );
  } else if (pageId === "insights" && isInsightsEntitled && !isOnlyCustomInsights) {
    return (
      <InsightsContextProvider>
        <InsightsList />
      </InsightsContextProvider>
    );
  } else if (pageId === "insights:newInsight") {
    return (
      <InsightsContextProvider>
        <NewInsight />
      </InsightsContextProvider>
    );
  } else if (showUpsell) {
    return (
      <InsightsContextProvider>
        <InsightsUpsell />
      </InsightsContextProvider>
    );
  }
}
